module.exports = __webpack_public_path__ + "img/imagen_parrafo_tres.db7b6119.png";